export default __webpack_public_path__ + "static/1-function-cddfdbfd6d36b58baf60980e8f0ad3d2.png";